import angular from 'angular';

import PrivilegeTemplatesPermissionPickerComponent from './privilege-templates-permission-picker-component';

export default angular
  .module('privilege-templates-permission-picker', [])
  .component('privilegeTemplatesPermissionPicker', new PrivilegeTemplatesPermissionPickerComponent());



// WEBPACK FOOTER //
// ./src/modules/privilege-templates/components/privilege-templates-permission-picker/privilege-templates-permission-picker-module.js